import React from 'react';
import styles from './style.module.css';

function Footer() {
  return (
    <footer className={styles.footer}>
      <p>
        Entre em contato conosco através dos seguintes canais de atendimento:
        <br />Tel. +55 (11) 3231-2201 ou por e-mail: eyseguroautomotivo@ey.com
      </p>
    </footer>
  );
}

export default Footer;
